<template>
    <div class="d-flex flex-nowrap gap-3">
        <GridButton
            :row="row"
            icon="fa-print"
            text="general.print"
            @click="emit('print', row ?? null, type)"
        />
        <DateComp
            v-if="props.value?.TimeValue !== null"
            :value="props.value?.TimeValue ?? null"
            format="TIME"
        />
    </div>
</template>

<script setup lang="ts">
import { DateComp, GridButton } from '@/components';
import { EventImplementation, type EventImplementationType } from '@/objects/generated';
import type { RaceControlItem } from '@/objects/RaceControlItem';

const props = defineProps<{
    value: EventImplementation | null;

    type: EventImplementationType;

    row?: RaceControlItem | null;
}>();

const emit = defineEmits<{
    (e: 'print', row: RaceControlItem | null, type: EventImplementationType): void;
}>();
</script>
